module.exports = __webpack_public_path__ + "img/data.21e75c7f.svg";